import React from 'react';
import PropTypes from 'prop-types';

const FaceMatch = ({ fill, ...props }) => (
  <svg
    width="18"
    height="18"
    viewBox="0 0 28 28"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M4.66699 9.33366V7.00033C4.66699 6.38149 4.91282 5.78799 5.35041 5.35041C5.78799 4.91282 6.38149 4.66699 7.00033 4.66699H9.33366M4.66699 18.667V21.0003C4.66699 21.6192 4.91282 22.2127 5.35041 22.6502C5.78799 23.0878 6.38149 23.3337 7.00033 23.3337H9.33366M18.667 4.66699H21.0003C21.6192 4.66699 22.2127 4.91282 22.6502 5.35041C23.0878 5.78799 23.3337 6.38149 23.3337 7.00033V9.33366M18.667 23.3337H21.0003C21.6192 23.3337 22.2127 23.0878 22.6502 22.6502C23.0878 22.2127 23.3337 21.6192 23.3337 21.0003V18.667M10.5003 11.667H10.512M17.5003 11.667H17.512M10.8892 17.8892C11.2694 18.2772 11.9176 18.1966 12.4185 18.4071C12.9193 18.6175 13.4571 18.7259 14.0003 18.7259C14.5436 18.7259 15.0814 18.6175 15.5822 18.4071C16.083 18.1966 16.7312 18.2772 17.1114 17.8892"
      stroke={fill || '#6B6C7B'}
      strokeWidth="2.48889"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

FaceMatch.propTypes = {
  fill: PropTypes.string,
};

export default FaceMatch;
